
export default function TileAdhesiveTierComparison() {
  const tiers = [
    {
      name: 'Everyday',
      features: [
        'Suitable for ceramic and porcelain tiles',
        'Interior wall and floor applications',
        'Standard setting time',
        'Good adhesion strength',
        'Ideal for DIY projects',
      ],
    },
    {
      name: 'Contractor Grade',
      features: [
        'All tile types including natural stone',
        'Interior and exterior use',
        'Fast setting formula',
        'Superior adhesion strength',
        'Flexible for substrate movement',
        'Water-resistant',
      ],
    },
    {
      name: 'Elite Pro',
      features: [
        'Premium formula for all tile types',
        'Heavy-duty commercial applications',
        'Ultra-fast setting',
        'Maximum adhesion strength',
        'Highly flexible',
        'Waterproof and frost-resistant',
        'Extended open time',
      ],
    },
  ];

  return (
    <section className="py-12 md:py-20 px-4 md:px-8 bg-gray-50 overflow-x-hidden">
      <div className="max-w-7xl mx-auto">
        <h2 className="font-['Montserrat'] font-bold text-2xl md:text-3xl lg:text-4xl text-center mb-4 text-[#1A1A1A]">
          Compare Tile Adhesive Tiers
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-10 md:mb-16 max-w-3xl mx-auto">
          Choose the performance level that matches your project requirements and budget.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {/* Everyday - Yellow */}
          <div className="rounded-lg shadow-md p-6 md:p-8" style={{ backgroundColor: '#F2C612' }}>
            <h3 className="font-['Montserrat'] font-bold text-xl md:text-2xl text-[#1A1A1A] mb-4">
              Everyday
            </h3>
            <ul className="space-y-3">
              {tiers[0].features.map((feature, index) => (
                <li key={index} className="flex items-start gap-2 text-sm md:text-base text-[#1A1A1A]">
                  <i className="ri-check-line text-[#1A1A1A] text-lg flex-shrink-0 mt-0.5"></i>
                  <span className="break-words">{feature}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Contractor Grade - Blue */}
          <div className="rounded-lg shadow-md p-6 md:p-8" style={{ backgroundColor: '#2D7AC2' }}>
            <h3 className="font-['Montserrat'] font-bold text-xl md:text-2xl text-white mb-4">
              Contractor Grade
            </h3>
            <ul className="space-y-3">
              {tiers[1].features.map((feature, index) => (
                <li key={index} className="flex items-start gap-2 text-sm md:text-base text-white">
                  <i className="ri-check-line text-white text-lg flex-shrink-0 mt-0.5"></i>
                  <span className="break-words">{feature}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Elite Pro - Red */}
          <div className="rounded-lg shadow-md p-6 md:p-8" style={{ backgroundColor: '#D42B2B' }}>
            <h3 className="font-['Montserrat'] font-bold text-xl md:text-2xl text-white mb-4">
              Elite Pro
            </h3>
            <ul className="space-y-3">
              {tiers[2].features.map((feature, index) => (
                <li key={index} className="flex items-start gap-2 text-sm md:text-base text-white">
                  <i className="ri-check-line text-white text-lg flex-shrink-0 mt-0.5"></i>
                  <span className="break-words">{feature}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
